import { IAction } from '../store';

export interface FileInfo {
    id: string;
    fileName: string;
    fileSize: number;
    magicBytes: string;
}

export interface IFileInfoState {
    fileInfo: FileInfo | null;
}

export const initialFileState: IFileInfoState = {
    fileInfo: null,
};

export const filesReducers = {
    appendFilesInfo(state: IFileInfoState, action: IAction<FileInfo[]>) {
        state.fileInfo = action.payload[0];
    },

    removeFile(state: IFileInfoState, _: IAction<string>) {
        state.fileInfo = null;
    },
};
